import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'qb-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [MatIconButton, MatIcon],
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild(TemplateRef<Element>) _dialogTemplate: TemplateRef<Element>;
  @Input() canDismiss: boolean = true;
  @Output() closing: EventEmitter<boolean> = new EventEmitter<boolean>();
  private _overlayRef: OverlayRef;
  private _portal: TemplatePortal;

  data: {
    content: string;
  };

  constructor(
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef
  ) {}

  ngAfterViewInit() {
    this._portal = new TemplatePortal(this._dialogTemplate, this._viewContainerRef);
  }

  ngOnDestroy() {
    if (this._overlayRef) {
      this._overlayRef.dispose();
    }
  }

  open(width?: number) {
    this._overlayRef = this._overlay.create({
      positionStrategy: this._overlay.position().global().centerHorizontally().centerVertically(),
      hasBackdrop: true,
      maxWidth: '95%',
      maxHeight: '80%',
      width: width ? width + 'px' : null,
      //scrollStrategy: this._overlay.scrollStrategies.block()
    });
    if (this.canDismiss) {
      this._overlayRef.backdropClick().subscribe(() => this._overlayRef.detach());
    }
    this._overlayRef.attach(this._portal);
  }

  close() {
    this.closing.emit(true);
    this._overlayRef?.detach();
    this._overlayRef?.dispose();
  }
}
